if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.currentlyDisabled = false;
        this.currentlyDisabled = this.getAttribute("currentlyDisabled");

        if (!this.currentlyDisabled) {
          this.form = this.querySelector("form");

          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

          /*this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");*/

          this.cart = document.querySelector("cart-drawer");

          // element
          this.notification = document.querySelector("cart-notification");
          this.notificationInner = document.getElementById("cart-notification");

          this.notificationXs = document.querySelector("cart-notification-xs");
          this.notificationInnerXs = document.getElementById(
            "cart-notification-xs"
          );

          this.submitButton = this.querySelector('[type="submit"]');
          if (document.querySelector("cart-drawer"))
            this.submitButton.setAttribute("aria-haspopup", "dialog");

          /*
        this.disableCartNotification = false;

        this.disableCartNotification = this.getAttribute(
          "disableCartNotification"
        );
        */

          this.isCartNotification = false;
          this.isCartNotification = this.getAttribute("isCartNotification");

          if (!this.isCartNotification) {
            this.form.querySelector("[name=id]").disabled = false;
          }
        } else {
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        let formData;

        if (!this.isCartNotification) {
          //const formData = new FormData(this.form);
          formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              "sections",
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append("sections_url", window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
        } else {
          // Add multiple items
          // https://shopify.dev/docs/api/ajax/reference/cart

          /*
          let __formData = new FormData(this.form);
          const data = {};
          __formData.forEach((value, key) => {
            data[key] = value;
          });
          */

          let straps = [];
          const inputs = this.form.querySelectorAll("input");
          inputs.forEach((input) => {
            const customValue = input.getAttribute("data-value");

            if (customValue !== null && input.checked) {
              straps.push({ quantity: 1, id: customValue });
            }
          });

          var _formData = {
            /*items: [
              { quantity: 2, id: 44804950458674 },
              { quantity: 1, id: 44804950458674 },
            ],*/
            items: straps,
            sections: this.cart
              .getSectionsToRender()
              .map((section) => section.id),
            sections_url: window.location.pathname,
          };

          config.method = "POST";
          config.headers["Content-Type"] = "application/json";
          config.body = JSON.stringify(_formData);
          this.cart.setActiveElement(document.activeElement);
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart /* || this.disableCartNotification*/) {
              // For strap
              //window.location = window.routes.cart_url;
              //return;
            }

            this.error = false;
            /*
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
            */
            this.cart.renderContents(response);

            // Only "Perception" paga has notification pane.
            if (
              this.notification != null &&
              !this.getAttribute("disableCartNotification")
            ) {
              this.notification.renderContents(response);
              document
                .querySelector("cart-notification-xs")
                .renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );

            // Close if this form is the notification
            if (this.isCartNotification) {
              /*
              this.notificationInner.classList.remove("notification-active");

              document
                .getElementById("cart-notification-xs")
                .classList.remove("notification-xs-active");
              */
              this.notification.close();
              this.notificationXs.close();
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        // Hide error
        /*
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
        */
      }
    }
  );
}
